module.exports = __webpack_public_path__ + "img/lorilo.940d4647.png";